import { takeEvery, put, call } from 'redux-saga/effects';
import * as actions from '../actions/creditUsage';
import * as API from '../api/creditUsage';
import { sessionErrorHandling } from './session';

function* list(action) {
    try {
        const { startDate, endDate } = action.payload;
        yield put({ type: actions.CREDIT_USAGE_REPORT_LANDING_PENDING });
        const payload = yield call(API.creditUsageReport, startDate, endDate);
        yield put({ type: actions.CREDIT_USAGE_REPORT_LANDING_FULFILLED, payload });
    }
    catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.CREDIT_USAGE_REPORT_LANDING_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}
function* download(action) {
    try {
        const { startDate, endDate, callback } = action.payload;
        yield put({ type: actions.CREDIT_USAGE_REPORT_DOWNLOAD_PENDING });
        const payload = yield call(API.downloadReport, startDate, endDate);
        yield put({ type: actions.CREDIT_USAGE_REPORT_DOWNLOAD_FULFILLED });

        if (callback) {
            callback(payload);
        }
    }
    catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.CREDIT_USAGE_REPORT_DOWNLOAD_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

function* aiList(action) {
    try {
        const { startDate, endDate } = action.payload;
        yield put({ type: actions.AI_CREDIT_USAGE_REPORT_LANDING_PENDING });
        const payload = yield call(API.aiCreditUsageReport, startDate, endDate);
        yield put({ type: actions.AI_CREDIT_USAGE_REPORT_LANDING_FULFILLED, payload });
    }
    catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.AI_CREDIT_USAGE_REPORT_LANDING_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}
function* aiDownload(action) {
    try {
        const { startDate, endDate, callback } = action.payload;
        yield put({ type: actions.AI_CREDIT_USAGE_REPORT_DOWNLOAD_PENDING });
        const payload = yield call(API.aiDownloadReport, startDate, endDate);
        yield put({ type: actions.AI_CREDIT_USAGE_REPORT_DOWNLOAD_FULFILLED });

        if (callback) {
            callback(payload);
        }
    }
    catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.AI_CREDIT_USAGE_REPORT_DOWNLOAD_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

function* systemList(action) {
    try {
        const { startDate, endDate } = action.payload;
        yield put({ type: actions.SYSTEM_CREDIT_USAGE_REPORT_LANDING_PENDING });
        const payload = yield call(API.systemCreditUsageReport, startDate, endDate);
        yield put({ type: actions.SYSTEM_CREDIT_USAGE_REPORT_LANDING_FULFILLED, payload });
    }
    catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.SYSTEM_CREDIT_USAGE_REPORT_LANDING_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

function* creditAccountList(action) {
    try {
        const { startDate, endDate } = action.payload;
        yield put({ type: actions.CREDIT_ACCOUNT_USAGE_REPORT_LANDING_PENDING });

        const payload = yield call(API.creditAccountUsageReport, startDate, endDate);

        yield put({ type: actions.CREDIT_ACCOUNT_USAGE_REPORT_LANDING_FULFILLED, payload });
    }
    catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };

        yield put({
            type: actions.CREDIT_ACCOUNT_USAGE_REPORT_LANDING_REJECTED,
            payload: errorMessage
        });

        yield call(sessionErrorHandling, error);
    }
}

function* creditAccountDownload(action) {
    try {
        const { startDate, endDate, callback } = action.payload;

        yield put({ type: actions.CREDIT_ACCOUNT_USAGE_REPORT_DOWNLOAD_PENDING });

        const payload = yield call(API.creditAccountDownloadReport, startDate, endDate);

        yield put({ type: actions.CREDIT_ACCOUNT_USAGE_REPORT_DOWNLOAD_FULFILLED });

        if (callback) {
            callback(payload);
        }
    }
    catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };

        yield put({
            type: actions.CREDIT_ACCOUNT_USAGE_REPORT_DOWNLOAD_REJECTED,
            payload: errorMessage
        });

        yield call(sessionErrorHandling, error);
    }
}

function* systemDownload(action) {
    try {
        const { startDate, endDate, callback } = action.payload;
        yield put({ type: actions.SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD_PENDING });
        const payload = yield call(API.systemDownloadReport, startDate, endDate);
        yield put({ type: actions.SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD_FULFILLED });

        if (callback) {
            callback(payload);
        }
    }
    catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

export default function* () {
    yield takeEvery(actions.CREDIT_USAGE_REPORT_LANDING, list);
    yield takeEvery(actions.CREDIT_USAGE_REPORT_DOWNLOAD, download);
    yield takeEvery(actions.AI_CREDIT_USAGE_REPORT_LANDING, aiList);
    yield takeEvery(actions.AI_CREDIT_USAGE_REPORT_DOWNLOAD, aiDownload);
    yield takeEvery(actions.SYSTEM_CREDIT_USAGE_REPORT_LANDING, systemList);
    yield takeEvery(actions.SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD, systemDownload);
    yield takeEvery(actions.CREDIT_ACCOUNT_USAGE_REPORT_LANDING, creditAccountList);
    yield takeEvery(actions.CREDIT_ACCOUNT_USAGE_REPORT_DOWNLOAD, creditAccountDownload);
}